/**
 * Include your custom JavaScript here.
 */

document.addEventListener("scroll", function () {
    const logo = document.getElementById("bbb_logo");

    // Total scrollable height
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;

    // Current scroll position percentage
    const scrolledPercent = (window.scrollY / scrollHeight) * 100;

    if (scrolledPercent >= 70) {
        logo.style.display = "block";
    } else {
        logo.style.display = "none";
    }
});

function initHeroSearch(section) {
  const heroSearch = section.querySelector("[data-hero-search]");
  if (heroSearch && typeof SearchBar !== "undefined") {
    new SearchBar(heroSearch);
  }
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-hero-search]").forEach((el) => {
    new SearchBar(el);
  });
});

// Initialize for Shopify sections (dynamic editor)
document.addEventListener("shopify:section:load", (event) => {
  initHeroSearch(event.target);
});